export let ModelType = /*#__PURE__*/function (ModelType) {
  ModelType["DISCOUNT"] = "discount";
  ModelType["SURCHARGE"] = "surcharge";
  return ModelType;
}({});